import axiosInstance from '../../../../common/axios.service';
import type {ADD_RACK_CATEGORY, UPDATE_RACK_CATEGORY} from './rackCategory.type';
import type FILTERS from '../../../../common/filters.type';

const rackCategoriesList = (values: FILTERS) => {
  return axiosInstance.get('rackcategory/', {params: values}).then((response) => {
    return response;
  });
};

const addRackCategory = (values: ADD_RACK_CATEGORY) => {
  return axiosInstance.post('rackcategory/', values).then((response) => {
    return response;
  });
};

const updateRackCategory = (values: {payload: UPDATE_RACK_CATEGORY; category_id: number}) => {
  return axiosInstance
    .put(`rackcategory/${values.category_id}`, values.payload)
    .then((response) => {
      return response;
    });
};

const rackCategoryServices = {
  rackCategoriesList,
  addRackCategory,
  updateRackCategory,
};

export default rackCategoryServices;
